/**
 * Browser entry point. Creates the canvas and starts the game.
 */
import { Game } from './app/game.ts';
import type { RawLevel } from './core/levels/load.ts';
import levels from 'virtual:levels';

const app = document.getElementById('app');

if (app) {
  const canvas = document.createElement('canvas');
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  canvas.style.display = 'block';
  app.appendChild(canvas);

  try {
    new Game(canvas, levels as unknown as RawLevel[]);
  } catch (err) {
    app.innerHTML = `<div class="boot"><h1>PAINT FACTORY</h1><p>ERROR</p><small>${String(err)}</small></div>`;
  }
}
